import { Select } from 'antd'
import React, { useEffect } from 'react'
import { toast } from 'react-toastify'
import { useGetCampaignTypesQuery } from '../../../redux/apis/campaignsManagement/types/cMTypesApiSlice'

const CampaignTypesDropdown = ({ onChange, onBlur, value }) => {
    const {data, isLoading,error} = useGetCampaignTypesQuery({
        page:"*",
        fields:['id','type'].join(",")
    })
    

    
	useEffect(()=>{
        if ( !error && !isLoading) {
            return
        }
        toast.error(error)
    },[error, isLoading])


    return (
        <div className=" mb-3">
            <label className="form-label" >Campaign Type</label>
            <br />
            <Select
                name='campaign_type'
                showSearch
                style={{
                    width: "100%"
                }}
                optionFilterProp="label"
                filterSort={(optionA, optionB) =>
                    (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                }
                defaultValue={value}
                value={value}
                onChange={e => onChange("campaign_type", e)}
                onBlur={onBlur}
                loading={isLoading}
                options={data?.data?.results?.map(x => {
                    return { label: x.type, value: x.id }
                })}
            />
        </div>
    )
}

export default CampaignTypesDropdown